export const sortingOptions = {
    'artist-a-to-z': 'Artist: A to Z',
    'artist-z-to-a': 'Artist: Z to A',
    'oldest-to-newest': 'Year: Oldest to Newest',
    'newest-to-oldest': 'Year: Newest to Oldest',
    'most-recent': 'Most Recent Additions',
    'least-recent': 'Least Recent Additions',
    'most-popular': 'Most Popular',
    'least-popular': 'Least Popular',
    'random': 'Random',
};
